// extracted by mini-css-extract-plugin
export default {"mainContainer":"Loader_mainContainer__-TVFE","loader":"Loader_loader__OO67O"};